import React, { FC } from 'react';
import { UitkSpacing } from 'uitk-react-spacing';
import { Search } from 'components/page-header/search';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import HeaderLogo from 'components/page-header/header-logo';
import LanguageSelector from 'components/page-header/language-selector';
import HeaderNavbar from 'components/page-header/header-navbar';
import {
  DocumentationHeaderFragment,
  DocumentationHeaderSubMenu,
  LanguageItemFragment,
  LanguageMenuFragment,
} from 'graphql/__generated__/types';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { ElasticSearch } from '../elastic-search';
import { Authentication } from '../authentication/authentication';

interface PageHeaderMobileProps {
  headerData: DocumentationHeaderFragment;
}

const PageHeaderMobile: FC<PageHeaderMobileProps> = ({ headerData }) => {
  const { logo, searchBox, languageMenu, primaryNavigation, authentication, secondaryNavigation, hubName } = headerData;
  const { subMenus, leadingIcon } = languageMenu as LanguageMenuFragment;
  const { items } = subMenus[0] as DocumentationHeaderSubMenu;

  return (
    <UitkSpacing padding={{ inline: 'two', blockstart: 'two' }}>
      <UitkLayoutFlex direction="column" justifyContent="space-between" className="height-full">
        <UitkLayoutFlexItem>
          <UitkLayoutFlex alignItems="center">
            <UitkLayoutFlexItem grow={1}>
              <div>
                <HeaderLogo logo={logo} hubName={hubName} />
              </div>
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem>
              <div data-testid="searchbox">
                <Experiment name="DevHub_Search_Behind_Login">
                  <ExperimentControl>
                    <Search searchInputProps={searchBox} />
                  </ExperimentControl>
                  <ExperimentVariant bucket={1}>
                    <ElasticSearch searchInputProps={searchBox} />
                  </ExperimentVariant>
                </Experiment>
              </div>
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem>
              <LanguageSelector languages={items as Array<LanguageItemFragment>} leadingIcon={leadingIcon.token} />
            </UitkLayoutFlexItem>
            <Experiment name="DevHub_AuthN_AuthZ">
              <ExperimentControl>
                <></>
              </ExperimentControl>
              <ExperimentVariant bucket={1}>
                <UitkLayoutFlexItem>
                  <Authentication authentication={authentication} />
                </UitkLayoutFlexItem>
              </ExperimentVariant>
            </Experiment>
          </UitkLayoutFlex>
        </UitkLayoutFlexItem>
        <UitkLayoutFlexItem>
          <HeaderNavbar primaryNavigation={primaryNavigation} secondaryNavigation={secondaryNavigation} />
        </UitkLayoutFlexItem>
      </UitkLayoutFlex>
    </UitkSpacing>
  );
};

export default PageHeaderMobile;
